/**
 * Application shell. Wraps `BrowserRouter` and the app-wide providers; the
 * actual routes live in `AppRoutes`.
 *
 * Keep this file thin — config and providers live elsewhere so the test
 * harness can swap them out without re-rendering the whole router.
 */

import { BrowserRouter } from "react-router-dom";
import { AppProviders } from "./providers";
import { AppRoutes } from "./router";

export function App() {
  return (
    <BrowserRouter>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </BrowserRouter>
  );
}
